export default "__VITE_ASSET__dbbaca55__"